<ng-container *ngIf="messageDetails">
  <div mat-dialog-title>
    <span class="dialog-title-label">{{ messageDetails.subject }}</span>
    <button
      *ngIf="data.fields.HasCloseButtonInHeader.value"
      (click)="dialogRef.close()"
      class="btn btn-default"
    >
      <i class="icon-close"></i>
    </button>
  </div>
  <div mat-dialog-content class="fs-16 mb-3">
    <div class="row mb-2">
      <div class="col-md-6">
        <i class="icon-mail mr-2"></i>
        <span class="font-weight-bold mr-2" *scText="sender"></span>
        <span class="font-italic">{{ messageDetails.author?.name }}</span>
      </div>
      <div class="col-md-6">
        <span class="font-weight-bold mr-2" *scText="date"></span>
        <span class="font-italic">{{
          messageDetails.createdDate | abDate
        }}</span>
      </div>
    </div>
    <div class="pre-wrap" [innerHtml]="messageDetails.body | safeHtml"></div>
  </div>
  <div mat-dialog-actions>
    <!--   <button
      class="btn btn-danger"
      (click)="deleteMessage()"
      *scText="delete"
    ></button>-->
    <ng-container *ngIf="data.fields.SubmitButtonLabel.value !== ''">
      <button
        class="btn btn-primary btn-mid btn-block btn-md-block-none"
        *scText="data.fields.SubmitButtonLabel"
        (click)="printMessage()"
      ></button>
    </ng-container>
    <ng-container *ngIf="data.fields.CancelButtonLabel.value !== ''">
      <button
        class="btn btn-link btn-with-icon text-left btn-block btn-md-block-none"
        (click)="dialogRef.close()"
      >
        <span *scText="data.fields.CancelButtonLabel"></span>
      </button>
    </ng-container>
  </div>
</ng-container>
<div *ngIf="!messageDetails" class="loader-bar"></div>
